/** `AlertHost`'s look (DESIGN_SYSTEM.md §5.2, QD8): web v1's warning modal's layout, in type and text roles. */
import { defineVariants } from "@rista/ui/library/theme/variants";

export const alertLook = defineVariants({
  slots: ["body", "title", "message", "actions"],
  base: (t) => ({
    body: { padding: t.space.xxxl },
    title: { ...t.type.title, color: t.color.text.primary, marginBottom: t.space.lg },
    message: { ...t.type.bodyLarge, color: t.color.text.primary },
    actions: { marginTop: t.space.xl, flexDirection: "row", justifyContent: "flex-end" },
  }),
});
